import axios from 'axios';
import {API_ROOT} from '../app/utils';

export function fetchContactsHistoryLogs () {
	return function (dispatch) {
		axios.get(API_ROOT + '/api/v1/history/contacts', {withCredentials: true}).then((response) => {
			dispatch({
				type: 'FETCH_CONTACTS_HISTORY_LOGS',
				payload: response.data
			})
		}).catch(e => {
			dispatch({
				type: 'FETCH_CONTACTS_HISTORY_LOGS',
				payload: e.response.data
			})
		})
	}
}

export function fetchNextContactsHistoryLogs (page) {
	return function (dispatch) {
		axios.get(API_ROOT + '/api/v1/history/contacts?page=' + page, {withCredentials: true}).then((response) => {
			dispatch({
				type: 'FETCH_NEXT_CONTACTS_HISTORY_LOGS',
				payload: response.data
			});

			let callNextContactsHistory = setTimeout(() => {

				if(response.data.pageInfo.next){
					dispatch(fetchNextContactsHistoryLogs(response.data.pageInfo.next))
				} else {
					clearTimeout(callNextContactsHistory);
				}

			}, 1000);
		})
	}
}

export function loadNextContactsHistory (boolean) {
	return {
		type: 'LOAD_NEXT_CONTACTS_HISTORY',
		payload: boolean
	}
}
